// Adónde puede llevar un enlace que escribió el asistente del chat.
//
// Lo que escribe el modelo no es de fiar: para contestar lee descripciones de movimientos
// que llegan de cartolas importadas y de Odoo, y quien escribe la glosa de una
// transferencia puede plantar ahí instrucciones que el modelo termine siguiendo. Un enlace
// a otro sitio armado así se lleva en la URL las cifras de la conversación con un solo
// clic, o se hace pasar por un enlace de la app.
//
// Por contrato, el asistente solo enlaza rutas internas copiadas de lo que devuelven las
// herramientas (`link`, `month1_link`...; ver DEEP LINKS en backend/routes/chat.py), y
// todas empiezan con `/`. Por eso acá se acepta eso y nada más; lo demás se muestra como
// texto.
//
// Que empiece con `/` no alcanza: `//sitio.com`, `/\sitio.com` y `/<tab>/sitio.com` también
// empiezan así, y el navegador los lee como otro dominio. Lo decide el mismo parser de URL
// que usa el navegador: si el destino no queda en este origen, no es una ruta interna.
//
// Devuelve el `href` tal cual, sin normalizar, para que una ruta válida llegue a React
// Router igual que antes; y `null` cuando no se debe enlazar.
export function rutaInternaDelChat(href) {
  if (typeof href !== "string" || !href.startsWith("/")) return null;
  let destino;
  try {
    destino = new URL(href, window.location.href);
  } catch {
    return null;
  }
  return destino.origin === window.location.origin ? href : null;
}
